export default "__VITE_ASSET__I4D9dNvB__"